import script from "./mealGrade.vue?vue&type=script&setup=true&lang=js"
export * from "./mealGrade.vue?vue&type=script&setup=true&lang=js"

import "./mealGrade.vue?vue&type=style&index=0&id=795c5db6&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795c5db6"]])

export default __exports__